module.exports = __webpack_public_path__ + "img/Kyocera_logo.a3f9eb13.png";